<template>
  <select
    class="form-select"
    v-model="itemSelecionado"
    required
  >
    <option
      disabled
      hidden
      value=""
    >
      <slot />
    </option>
    <option
      disabled
      hidden
      :value="null"
    >
      <slot />
    </option>
    <option
      v-for="item in items"
      :key="item[campoAlvo] || item"
      :value="item[campoAlvo] || item"
    >
      {{ item.nome || item.titulo }}
    </option>
  </select>
</template>

<script setup>
defineProps({
  items: {
    type: Array,
    required: true,
  },
  campoAlvo: {
    type: String,
    default: "id",
  },
});

const itemSelecionado = defineModel({ default: "" });
</script>

<style scoped>
.field-label required {
  color: black;
}
</style>
